import React, { useState } from 'react';
import PlanoDeContasAdd from './add';
import PlanoDeContasSearch from './search';
import ButtonOptions from '../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../components/NovoSistema/HeaderButtons';

export default function PlanoDeContas() {
  const [option, setOption] = useState('search');
  return (
    <main>
      {option === 'search' && (
        <HeaderButtons>
          <ButtonOptions buttonName="Incluir" border="#333F50" yourFunction={() => setOption('add')} />
          <ButtonOptions buttonName="Editar" border="#333F50" disabled={true} />
        </HeaderButtons>
      )}
      {option === 'search' && <PlanoDeContasSearch />}
      {option === 'add' && <PlanoDeContasAdd setOption={setOption} />}
    </main>
  );
}
